import {
  FlexColumn,
} from '@equifinance/shared';
import styled from 'styled-components';
import { ChecklistDocument } from '../../../../../../contexts';
import DocumentItem from './DocumentItem';

const DocumentListContainer = styled(FlexColumn)`${({ theme }) => `
  margin-top: ${theme.padding[1]};
  gap: ${theme.padding[3]};
`}`;

export default function DocumentList({ documents }: { documents: ChecklistDocument[], }) {
  return (
    <DocumentListContainer>
      {documents.map(
        (document: ChecklistDocument) => (
          <DocumentItem
            key={document.documentId}
            document={document}
          />
        ),
      )}
    </DocumentListContainer>
  );
}
